<!-- Marketing submenu section -->
<ul
  class="mt-submenu-sidebar-link-wrapper mt-white sidebar-submenu submenu-wrapper list-unstyled bg-white shadow-sm position-absolute"
  *transloco="let translate"
  data-cy="marketing-sidebar-submenu"
>
  <ng-container *ngIf="marketingMenus$ | async as marketingMenus">
    <ng-container *ngFor="let menu of marketingMenus">
      <ng-container [ngSwitch]="menu.name">
        <div *ngSwitchCase="'CAMPAIGNS'" mt-claim-authorization [requiredClaim]="'Campaign:View'">
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div *ngSwitchCase="'events'" mt-claim-authorization [requiredClaim]="'Event:View'">
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show link__inactive"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div
          *ngSwitchCase="'navi_dashboard_overview'"
          mt-claim-authorization
          [requiredClaim]="'Campaign:View'"
        >
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div *ngSwitchCase="'target_group_s'" mt-claim-authorization [requiredClaim]="'TargetGroups:View'">
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div *ngSwitchCase="'notifications'" mt-claim-authorization [requiredClaim]="'Notification:View'">
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div *ngSwitchCase="'performance_feed'" mt-claim-authorization [requiredClaim]="'TargetGroups:View'">
          <li>
            <a
              [routerLink]="menu.url"
              routerLinkActive="active"
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          </li>
        </div>

        <div *ngSwitchCase="'recipients'" mt-claim-authorization [requiredClaim]="'TargetGroups:View'">
          <li
            class="position-relative parent-liwrapper"
            [ngClass]="{
              link__inactive: (menu.name | submenuInactive: authorizationScope)
            }"
           
          >
            <a
              class="show"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
            >
              <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
            </a>
          <ng-container *ngIf="menu.submenu && menu.isDropdownOpen">
            <ul class="list-unstyled submenu-thirdwrapper bg-white">
            <ng-container *ngFor="let subMenu of menu.submenu">
              <li
                [ngClass]="{
                  link__inactive: (menu.name | submenuInactive: authorizationScope)
                }"
                class="mt-submenu-title_subtitle-wrapper nav-item"
              >
                <a 
                  [routerLink]="subMenu.url" 
                  routerLinkActive="active" 
                  class="show"
                  [ngClass]="{
                    link__inactive: (menu.name | submenuInactive: authorizationScope)
                  }"
                >
                  <ng-container class="mt-submenu-icon marleft20">
                    <mt-svg class="h12 mt-submenu-icon" [ngClass]="(menu.name | submenuInactive: authorizationScope) ? 'mt-grau' : 'mt-brand-100'" src="{{ subMenu.image }}"> </mt-svg>
                  </ng-container>
                  <span
                    class="mt-submenu-title"
                    [transloco]="subMenu.name"
                    [attr.data-cy]="menu.name + '-subMenu-' + subMenu.name"
                  ></span>
                </a>
              </li> 
            </ng-container>
            </ul>
          </ng-container>
          </li>

        </div>

        <div *ngSwitchCase="'Leads'" mt-claim-authorization [requiredClaim]="'TargetGroups:View'">
          <ng-container *ngIf="navigationSidebarService.isRecipientsLeads$ | async as recipientsLeads">
            <li
              *ngIf="recipientsLeads.recordForeignContacts || recipientsLeads.recordForeignDomains"
              [ngClass]="{
                link__inactive: (menu.name | submenuInactive: authorizationScope)
              }"
              class="position-relative parent-liwrapper"
             
            >
              <a
                class="show"
                [ngClass]="{
                  link__inactive: (menu.name | submenuInactive: authorizationScope)
                }"
              >
                <ng-container
                  [ngTemplateOutlet]="renderSideMenuData"
                  [ngTemplateOutletContext]="{ menu }"
                ></ng-container>
              </a>
              <ng-container *ngIf="menu.isDropdownOpen">
                <ul class="list-unstyled submenu-thirdwrapper bg-white">
                <ng-container *ngFor="let subMenu of menu.submenu; let i = index">
                  <li
                    *ngIf="
                      subMenu.name === 'accounts'
                        ? recipientsLeads.recordForeignDomains
                        : recipientsLeads.recordForeignContacts
                    "
                    [ngClass]="{
                      link__inactive: (menu.name | submenuInactive: authorizationScope)
                    }"
                    class="mt-submenu-title_subtitle-wrapper"
                  >
                    <a 
                      [routerLink]="subMenu.url" 
                      routerLinkActive="active" 
                      class="show"
                      [ngClass]="{
                        link__inactive: (menu.name | submenuInactive: authorizationScope)
                      }"
                    >
                      <div class="mt-submenu-icon">
                        <mt-svg class="h12 mt-submenu-icon" [ngClass]="(menu.name | submenuInactive: authorizationScope) ? 'mt-grau' : 'mt-brand-100'" src="{{ subMenu.image }}"> </mt-svg>
                      </div>
                      <span
                        class="mt-submenu-title"
                        [transloco]="subMenu.name"
                        [attr.data-cy]="menu.name + '-subMenu-' + subMenu.name"
                      ></span>
                    </a>
                  </li>
                </ng-container>
                </ul>
              </ng-container>
            </li>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <!-- Displays sidemenu data -->
    <ng-template let-menu="menu" #renderSideMenuData>
      <div class="mt-submenu-icon">
        <mt-svg
          class="tiny-svg"
          [ngClass]="(menu.name | submenuInactive: authorizationScope) ? 'mt-grau' : 'mt-brand-100'"
          src="{{ menu.image }}"
        >
        </mt-svg>
      </div>
      <span class="mt-submenu-title inline-block" [transloco]="menu.name" [attr.data-cy]="'menu-' + menu.name"></span>
      <span *ngIf="menu.hasCounter" class="mt-submenu-counter">
        <ng-container [ngSwitch]="menu.name">
          <ng-container *ngSwitchCase="'CAMPAIGNS'">
            {{ campaignCount }}
          </ng-container>

          <ng-container *ngSwitchCase="'events'">
            {{ eventCount }}
          </ng-container>

          <ng-container *ngSwitchCase="'notifications'">
            {{ notificationCount }}
          </ng-container>

          <ng-container *ngSwitchCase="'target_group_s'">
            {{ targetGroupCount }}
          </ng-container>
        </ng-container>
      </span>
      <mt-svg
        *ngIf="!menu.hasCounter && menu.submenu && menu.submenu.length"
        class="mt-submenu-dropdown-arrow martop4 mt-submenu-icon mt-brand-100"
        src="assets/images/svgs/arrow-right.svg"
      >
      </mt-svg> </ng-template
  ></ng-container>
</ul>
